export default "__VITE_PUBLIC_ASSET__0810e52b__"